import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({ providedIn: 'root' })
export class AuthService {
  /**
   * Role claims live only in the JWT (ClaimTypes.Role, written as the short "role"
   * claim by JwtSecurityTokenHandler) — this is the same source ASP.NET Core's
   * [Authorize(Roles=...)] checks server-side, so the frontend guard can't drift
   * from what the backend actually enforces.
   */
  getRoles(): string[] {
    const token = localStorage.getItem('token');
    if (!token) {
      return [];
    }

    try {
      const payload: any = jwtDecode(token);
      const roleClaim = payload?.role ?? payload?.roles;
      if (!roleClaim) {
        return [];
      }
      return Array.isArray(roleClaim) ? roleClaim.map(String) : [String(roleClaim)];
    } catch {
      return [];
    }
  }

  hasRole(requiredRoles: string[]): boolean {
    if (!requiredRoles || requiredRoles.length === 0) {
      return true;
    }
    const roles = this.getRoles();
    return requiredRoles.some((r) => roles.includes(r));
  }

  isLoggedIn(): boolean {
    return localStorage.getItem('isLoggedIn') === 'yes' && !!localStorage.getItem('token');
  }
}
